export const mangeCardPermission = [
  {
    integrationType: "Booking.com",
    permissionCards: [
      "Service Level",
      "Area of Operation",
      "Rate",
      "Pick-up Instruction",
      "Pick-up Timings",
      "Contact Information",
      "Auto Driver Events",
      "Commission Rule",
      "Dispatcher",
      "Stop Sale",
      "Campaigns",
      "Automated Dispatch",
      "CS Communication",
      "Analysis & Rate Automation",
      "RideLink",
    ],
  },
  {
    integrationType: "WorldTransfer.com",
    permissionCards: [
      "Service Level",
      "Area of Operation",
      "Rate",
      "Pick-up Instruction",
      "Pick-up Timings",
      "Contact Information",
      "Auto Driver Events",
      "Commission Rule",
      "Dispatcher",
      "Stop Sale",
      "Campaigns",
      "Automated Dispatch",
      "CS Communication",
      "Analysis & Rate Automation",
      "RideLink",
    ],
  },
  {
    integrationType: "Trip.com",
    permissionCards: [
      "Service Level",
      "Area of Operation",
      "Rate",
      "Pick-up Instruction",
      "Pick-up Timings",
      "Contact Information",
      "Auto Driver Events",
      "Commission Rule",
      "Dispatcher",
      "Stop Sale",
      "Campaigns",
      "Automated Dispatch",
      "CS Communication",
      "Analysis & Rate Automation",
      "RideLink",
    ],
  },
  {
    integrationType: "Mozio",
    permissionCards: ["Auto Driver Events"],
  },
];
